import { ref } from 'vue';

const projectTranslations = ref([]);

export function useProjectTranslations() {
  function setProjectTranslations(translations: any[]) {
    projectTranslations.value = translations;
  }

  return {
    projectTranslations,
    setProjectTranslations,
  };
}